import isNumber from 'lodash/isNumber'

export default PotManager

/** @ngInject */
function PotManager($rootScope, User, ErrorCatcher) {
    let pot = {
        total: null,
        real: null,
        estimated: null,
    }

    const update = () =>
        User.getPotBalance().$promise
        .then((response) => {
            pot.total = (Number(response.real) + Number(response.estimated))
            pot.real = (Number(response.real))
            pot.estimated = (Number(response.estimated))
            $rootScope.$emit('pot-updated', pot)
        })
        .catch(ErrorCatcher.catchError)

    const getPotBalance = function () {
        if (!isNumber(pot.total) || !isNumber(pot.real) || !isNumber(pot.estimated)) {
            update()
        }
        return pot
    }

    const resetPot = () => {
        pot = {
            total: null,
            real: null,
            estimated: null,
        }
    }

    const watch = (callback) => $rootScope.$on('pot-updated', (event, updatedPot) => callback(updatedPot))

    return {
        getPotBalance,
        resetPot,
        watch,
        update,
    }
}



// WEBPACK FOOTER //
// ./src/services/pot/service.js